import { render } from "./vxeTableCol.vue?vue&type=template&id=1b67f0a4&scoped=true"
import script from "./vxeTableCol.vue?vue&type=script&lang=js"
export * from "./vxeTableCol.vue?vue&type=script&lang=js"

import "./vxeTableCol.vue?vue&type=style&index=0&id=1b67f0a4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b67f0a4"]])

export default __exports__